export enum BetClass {
    MAINBET = 1,
    SIDEBET,
    INSURANCE,
    PAIR,
}
